module.exports = __webpack_public_path__ + "static/media/logo-yen.94a9e893.svg";